import { render } from "./AppMarketSection.vue?vue&type=template&id=69ce3ce3"
import script from "./AppMarketSection.vue?vue&type=script&lang=js"
export * from "./AppMarketSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__